import { createContext } from 'react';
import type { MeQuery } from '@/gql/graphql';

export type MeUser = NonNullable<MeQuery['me']>;

export interface SessionContextValue {
  me: MeUser | null;
  loading: boolean;
  refresh: () => Promise<unknown>;
}

export const SessionContext = createContext<SessionContextValue | null>(null);
